import { EndpointSetting } from "@/constants/app/type"
import {
  hydrateHotelFormSearchFromApi,
  pickHotelApiSearchCriteria,
} from "@/utils/hotel/hydrateHotelFormSearchFromApi"
import {
  attachSearchIdToHotelRecord,
  pickPageSearchId,
} from "@/utils/hotel/resolveHotelRecordSearchId"
import { HotelFeePolicy, HotelState } from "../type"
import { resolveHotelFeePolicies } from "@/utils/hotel/resolveHotelFeePolicies"

export const callbackHotelSearch: EndpointSetting['caller'] = (
  state: HotelState,
  action: any,
  endpointName: any
) => {
  state.hotels_search.loading = false
  state.hotels_search.called = true
  state.hotels_search.error = null

  state.formSearch = {
    ...state.formSearch,
    page: action.meta.arg.body.page,
    pageSize: action.meta.arg.body.pageSize,
  }

  if (
    !state.hotels_search.primaryKeys?.length ||
    (action.meta.arg.body.page === 0 && state.mode !== 'maps')
  ) {
    state.hotels_search.primaryKeys = []
  }

  const { records, pagination, feePolicies } = action.payload

  state.hotels_search.feePolicies = resolveHotelFeePolicies(
    feePolicies,
    state.hotels_search.feePolicies,
  )

  const searchCriteria = pickHotelApiSearchCriteria(action.payload)
  if (searchCriteria) {
    hydrateHotelFormSearchFromApi(state.formSearch, searchCriteria)
  }

  const pageSearchId = pickPageSearchId(action.payload, searchCriteria)

  for (let i = 0; i < records.length; i++) {
    const hotel = attachSearchIdToHotelRecord(records[i], pageSearchId)
    if (state.firstHotel === null) {
      state.firstHotel = hotel
    }
    state.hotels_search.data[hotel.id] = hotel
    if (state.hotels_search.primaryKeys.indexOf(hotel.id) < 0) {
      state.hotels_search.primaryKeys.push(hotel.id)
    }
    for (let u = 0; u < hotel.nearbyLocations?.nearestHotels?.length; u++) {
      const nearHotel = attachSearchIdToHotelRecord(
        hotel.nearbyLocations.nearestHotels[u],
        hotel.searchId ?? pageSearchId,
      )
      state.hotels_search.data[nearHotel.id] = nearHotel
    }
  }

  state.hotels_search.primaryKeysForMaps = (state.hotels_search.primaryKeys || []).slice(0, 10)

  state.hotels_search.filter = {
    ...pagination,
    ...action.meta.arg.body
  }
}